"use server";

import { auth } from "@/auth";
import { validateParams } from "@/lib/utils";
import z from "zod";
import type { ActionResult } from "@/types/server-action";
import { updateDraftCurrentStep } from "@/lib/cat/draft-current-step";
import {
  buildDraftLockHolder,
  DraftLockDeniedError,
} from "@/lib/cat/draft-lock";
import type { Draft } from "@/prisma/generated/client";

const updateDraftCurrentStepSchema = z.object({
  draftId: z.number().int().positive(),
  stepId: z.string().min(1),
});

export async function updateDraftCurrentStepAction(
  params: z.infer<typeof updateDraftCurrentStepSchema>,
): Promise<ActionResult<Draft>> {
  try {
    const session = await auth();
    if (!session?.user?.id) {
      return { success: false, message: "Non authentifié." };
    }

    const { draftId, stepId } = validateParams(
      updateDraftCurrentStepSchema,
      params,
    );

    const lockHolder = buildDraftLockHolder(session.user);

    const savedDraft = await updateDraftCurrentStep({
      draftId,
      stepId,
      holder: lockHolder,
    });

    return { success: true, data: savedDraft };
  } catch (error) {
    console.error("[updateDraftCurrentStepAction]", error);

    if (error instanceof DraftLockDeniedError) {
      return { success: false, message: error.message };
    }

    if (error instanceof Error && error.message === "Brouillon introuvable.") {
      return { success: false, message: error.message };
    }

    if (error instanceof Error && error.message.startsWith("Étape inconnue")) {
      return { success: false, message: error.message };
    }

    return { success: false, message: "Une erreur serveur est survenue." };
  }
}
